import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';

export interface SegmentedToggleItem {
  id: string;
  label: string;
  icon?: string;
  disabled?: boolean;
  tooltip?: string;
}

@Component({
  selector: 'app-segmented-toggle',
  standalone: true,
  imports: [CommonModule, MatIconModule, MatTooltipModule],
  templateUrl: './segmented-toggle.component.html',
  styleUrls: ['./segmented-toggle.component.scss'],
})
export class SegmentedToggleComponent {
  @Input({ required: true }) options: ReadonlyArray<SegmentedToggleItem> = [];
  @Input({ required: true }) activeId: string | null = null;
  @Input() ariaLabel = 'Segmented toggle';
  @Input() showActiveCheckIcon = false;
  @Input() disabled = false;
  @Output() activeIdChange = new EventEmitter<string>();

  protected onSelect(option: SegmentedToggleItem) {
    if (this.disabled || option.disabled || option.id === this.activeId) {
      return;
    }
    this.activeIdChange.emit(option.id);
  }
}
